export enum UserGroupTypes {
    editor = 'editor',
    organization = 'organization',
    user = 'user',
}
